import { render, staticRenderFns } from "./nxNodata.vue?vue&type=template&id=433b1fa3&scoped=true&"
import script from "./nxNodata.vue?vue&type=script&lang=js&"
export * from "./nxNodata.vue?vue&type=script&lang=js&"
import style0 from "./nxNodata.vue?vue&type=style&index=0&id=433b1fa3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433b1fa3",
  null
  
)

export default component.exports